module.exports = __webpack_public_path__ + "images/menu-retract.214a05922f8d11c6cdf15e04987f484f.png";